import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getFileUndersRecentPopular } from "../api/getFileUnderPosts";
import Spinner from "react-bootstrap/Spinner";

class RecentPopularTagsContainer extends React.Component {
  componentDidMount() {
    const { days } = this.props;
    this.props.request(days);
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || {};
    const tags = (result && result.tags) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    return render({ tags, loading, failure });
  };
}

RecentPopularTagsContainer.defaultProps = {};
export default CreateContainer(getFileUndersRecentPopular, RecentPopularTagsContainer);
